import { c as _c } from "react/compiler-runtime";
import React from "react";
export const SearchContentFallback = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-center h-full w-full"><div className="text-center p-8"><div className="text-4xl mb-4">⚠️</div><h3 className="text-lg font-semibold text-gray-900 mb-2">Search Interface Error</h3><p className="text-gray-600 text-sm mb-4">The search interface encountered an error. Please refresh the page to try again.</p><button onClick={_temp} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">Refresh Page</button></div></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="flex flex-col lg:flex-row w-full h-full">{t1}{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp() {
  return window.location.reload();
}